/* dashboard-rediseno (15-oct-2026): EL TIPO DE UN DOCUMENTO EN LA TARJETA (A13).

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   Icono y nombre por tipo: PDF (hoja), Word (hoja con letra), PowerPoint (pantalla), Text
   (renglones), Photos (imagen) y YouTube (video). Sale de lo que el servidor ya manda
   (`file_type` y, si falta, la extension del nombre): cero llamadas.

   Los nombres de formato (PDF, Word, PowerPoint, YouTube) son nombres propios y se escriben
   igual en los dos idiomas; los dos que si se traducen usan las llaves de la casa: "Text" es
   `dashboard:panel.tipo_texto` (texto nuevo de la seccion 5) y "Photos" es
   `dashboard:fotos.tipo` (el de hoy).

   El renglon del tipo ("{tipo}, {n} questions, {n} flashcards") une las piezas con coma, con
   las palabras que la app ya tiene (`dashboard:partes_padre.conteo_*`); una cuenta en cero no
   se escribe. */
import React from 'react';
import { AlignLeft, FileText, FileType, Image, Mic, Presentation, Video } from 'lucide-react';
import { tipoDeMaterial } from '../../lib/tipoDeMaterial';

const POR_EXTENSION = {
  pdf: 'pdf', docx: 'word', doc: 'word', pptx: 'powerpoint', ppt: 'powerpoint',
  txt: 'texto', text: 'texto', fotos: 'fotos', youtube: 'youtube',
};
const NOMBRES_PROPIOS = { pdf: 'PDF', word: 'Word', powerpoint: 'PowerPoint', youtube: 'YouTube' };
const ICONOS = { pdf: FileText, word: FileType, powerpoint: Presentation, texto: AlignLeft, fotos: Image, youtube: Video, audio: Mic };

const minusculas = (v) => (typeof v === 'string' ? v.trim().toLowerCase() : '');

export function claveDelTipo(doc) {
  const propio = POR_EXTENSION[minusculas(doc && doc.file_type)];
  if (propio) return propio;
  // El audio (t7-2a #529: el alumno no lo sube hoy, pero si llega se pinta con su microfono).
  if (tipoDeMaterial(doc) === 'audio') return 'audio';
  const nombre = minusculas(doc && (doc.original_filename || doc.filename));
  const punto = nombre.lastIndexOf('.');
  const ext = punto < 0 ? '' : nombre.slice(punto + 1);
  return POR_EXTENSION[ext] || 'pdf';
}

export function nombreDelTipo(clave, t, doc) {
  if (clave === 'texto') return t('dashboard:panel.tipo_texto');
  if (clave === 'fotos') return t('dashboard:fotos.tipo');
  // El audio se nombra por su formato (MP3, M4A...), como PDF: un nombre propio, no un texto.
  if (clave === 'audio') {
    const ft = minusculas(doc && doc.file_type);
    return ft && ft !== 'audio' ? ft.toUpperCase() : 'Audio';
  }
  return NOMBRES_PROPIOS[clave] || NOMBRES_PROPIOS.pdf;
}

export const SEPARADOR_DEL_RENGLON = ', ';

export function conteosDe(preguntas, flashcards, t) {
  const piezas = [];
  if (preguntas > 0) piezas.push(t('dashboard:partes_padre.conteo_preguntas', { count: preguntas }));
  if (flashcards > 0) piezas.push(t('dashboard:partes_padre.conteo_flashcards', { count: flashcards }));
  return piezas;
}

export function renglonDelTipo(tipo, preguntas, flashcards, t, conConteos = true) {
  const piezas = [tipo, ...(conConteos ? conteosDe(preguntas, flashcards, t) : [])].filter(Boolean);
  return piezas.join(SEPARADOR_DEL_RENGLON);
}

/* estilos-1 (Bloque C, 4.4): con un examen en `documents.estilo`, su nombre CORTO (del catalogo del servidor) en
   naranja y seminegrita SUSTITUYE a la palabra del tipo: "NCLEX, 52 questions, 28 flashcards"; mientras procesa,
   "NCLEX"; en el padre partido, "NCLEX, 3 of 3 parts ready" (`resto` es ese texto). Sin estilo nadie lo llama: el
   renglon de hoy, byte a byte. Va dentro del mismo renglon con "...", asi que el alto del detalle no cambia. */
export const NOMBRE_DEL_ESTILO = 'font-semibold text-[#FF6B00]';

export function renglonConEstilo(corto, piezas = []) {
  const resto = (piezas || []).filter(Boolean);
  return (
    <>
      <span className={NOMBRE_DEL_ESTILO} data-estilo="">{corto}</span>
      {resto.length > 0 ? `${SEPARADOR_DEL_RENGLON}${resto.join(SEPARADOR_DEL_RENGLON)}` : null}
    </>
  );
}

// El trazo de cada tipo; la caja (y su rotulo para el lector de pantalla) la pone la tarjeta.
export function IconoDelTipo({ clave, className }) {
  const Icono = ICONOS[clave] || FileText;
  return <Icono className={className} aria-hidden="true" />;
}
